'use client'

import Footer from '@/components/landing-page/footer'

import {
  Box,
  Text,
  Flex,
  Icon,
  Button,
  Image,
  useDisclosure,
  Link,
} from '@chakra-ui/react'
import { Share2Icon } from 'lucide-react'

import SharePage from '@/components/how-earnings-work/share-page'
import { useUser } from '@/src/store/user-store'

export default function Home() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { user } = useUser()

  return (
    <>
      <div className="bg-white">
        {/* <Analytics eventType="how_earnings_works" /> */}
        <SharePage
          isOpen={isOpen}
          onClose={onClose}
          url="viewer-earnings"
        />
        <Button
          position={'fixed'}
          zIndex={100}
          right={'1em'}
          leftIcon={<Icon as={Share2Icon} />}
          bottom={'2em'}
          rounded={'full'}
          backgroundColor={'lyk-green'}
          _hover={{ opacity: 0.6 }}
          color={'white'}
          onClick={onOpen}
        >
          Share page
        </Button>

        <Box
          position={'relative'}
          className="w-full"
          id="learn-more"
          backgroundColor={'lyk-green'}
        >
          <Flex
            w={'100%'}
            justify={'space-between'}
            align={'center'}
            flexDir={['column', 'column', 'row']}
          >
            <Box
              width={'100%'}
              paddingY={['2em', '2em', '2em']}
              flex={['none', 'none', 1]}
            >
              <Box paddingLeft={[4, 4, '30%']}>
                <Text color={'white'} fontWeight={700} fontSize={30}>
                  Introducing, LYKSTAGE
                </Text>
                <Text fontSize={[24]} color={'white'}>
                  A platform for both creators and viewers to earn.
                </Text>
              </Box>
            </Box>

            <Box display={['none', 'none', 'block']} flex={[1, 1, 1.5]}>
              <Image
                src={'/how-earnings-work/hero.png'}
                alt="How Earnings Work"
              />
            </Box>

            <Box display={'flex'} justifyContent={'flex-end'}>
              <Image
                display={['block', 'block', 'none']}
                src={'/how-earnings-work/hero_mobile.png'}
                alt="How Earnings Work"
                position={['relative', 'relative', 'absolute']}
                right={0}
                left={'52px'}
                bottom={['-1em', '-1em', '-0.4em']}
                w={['90%', '90%', '55%']}
              />
            </Box>
          </Flex>
        </Box>
        <section
          className="mx-auto my-8  w-full max-w-[1200px]  grow bg-white md:my-0 md:w-[90%] md:py-8"
          id="learn-more"
        >
          <div className="flex w-full flex-col items-center justify-center gap-5 overflow-hidden px-4 py-5 md:px-16 lg:flex-row lg:px-16">
            <div className="flex w-full flex-1 flex-col pr-0 sm:text-center lg:pr-16 lg:text-left">
              <h2
                className="pb-6 text-xl font-bold text-text-black sm:text-2xl md:text-3xl"
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
              >
                Sounds too good to be true? It&apos;s just ads!
              </h2>

              <p
                className="text-base leading-6 text-text-black/80"
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
              >
                LYKSTAGE&apos;s revenue model is designed to maximize earning
                potential for both creators and viewers through a sophisticated
                ad-serving algorithm. Unlike traditional platforms that serve
                ads at fixed intervals, LYKSTAGE uses an intelligent algorithm
                to determine when and where ads should be placed.
              </p>

              {/* <Text fontWeight={700} marginTop={5} color={'lyk-green'}>
              1 Ad set (2 Ads) - Every 5 minutes
            </Text> */}
            </div>
            <div
              className="relative mt-4 flex-1"
              data-aos="zoom-in-up"
              data-aos-anchor-placement="top-bottom"
            >
              <Image
                src="/how-earnings-work/ads.png"
                alt="Sounds too good to be true? It’s just ads!"
              />
            </div>
          </div>
        </section>

        {/* <section className="mx-auto w-full max-w-[1200px] grow  bg-white pb-16 pt-5 md:w-[90%]">
        <Section3
          title="Thoughtful viewership and earning through watch time units."
          description="LYKSTAGE rewards viewers for their time. For every minute spent watching videos, viewers earn Watch Time Units. These units are a form of digital currency (LYK Coins) on the platform, which viewers can redeem or use for various benefits, such as renting pay-per-view content."
          url="https://cdn.lykstage.com/videos/video3.mp4"
        />
      </section> */}

        <section
          className="mx-auto w-full max-w-[1200px] grow bg-white md:my-0 md:w-[90%]"
          id="learn-more"
        >
          <Flex
            flexDir={['column-reverse', 'column-reverse', 'row']}
            className="flex w-full  items-center justify-center gap-5 overflow-hidden px-4 md:px-16 lg:px-16"
          >
            <div
              className="relative flex-1"
              data-aos="zoom-in-up"
              data-aos-anchor-placement="top-bottom"
            >
              <Image
                src="/how-earnings-work/howdoesitwork.png"
                alt="Watchtime"
              />
            </div>
            <div className="flex w-full flex-1 flex-col pr-0 sm:text-center lg:pr-16 lg:text-left">
              <h2
                className="pb-6 text-xl font-bold text-text-black sm:text-2xl md:text-3xl"
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
              >
                How does it work?
              </h2>

              <p
                className="mb-5 text-base leading-6 text-text-black/80"
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
              >
                This algorithm dynamically evaluates each piece of content along with real viewer engagement to determine if and when ads should be served — as pre-roll, mid-roll, or post-roll.
                <br /><br />
                When an ad is served during viewing and watched fully, the watch time built on that content becomes monetized — enabling creator earnings and viewer rewards. Monetization happens only when genuine viewing leads to ads being served and completed — ensuring value is created through real attention, not ad volume.
              </p>

              <Box display={['none', 'none', 'block']}>
                <br />
                <br />
              </Box>
            </div>
          </Flex>
        </section>

        <Box marginTop={'-3em'} bg={'lyk-green'} h={'5em'} w={'100%'} />

        <br />
        <br />

        <section
          className="mx-auto my-6 mb-0 w-full max-w-[1200px] grow bg-white  md:w-[90%] md:py-8"
          id="learn-more"
        >
          <div className="flex w-full flex-col items-center justify-center gap-5 overflow-hidden px-4 py-5 md:px-16 lg:flex-row lg:px-16">
            <div className="flex w-full flex-1 flex-col pr-0 sm:text-center lg:pr-16 lg:text-left">
              <h2
                className="pb-6 text-xl font-bold text-text-black sm:text-2xl md:text-3xl"
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
              >
                Start earning with your watchtime!
              </h2>

              <p
                className="mb-5 text-base leading-6 text-text-black/80"
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
              >
                With LYKSTAGE, viewers are rewarded for their Watchtime.
              </p>

              <p
                className="text-base leading-6 text-text-black/80"
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
              >
                A unit of watch time can be defined as a block of 30 sec
                uninterrupted video viewing. Each watchtime in a video in a 24
                hour period allows you to earn from that videos total revenue!
              </p>

              <Text fontWeight={700} marginTop={5} color={'lyk-green'}>
                For a viewer, in a 24 hour period, your watchtime units cap out
                at 6 hours!
              </Text>
            </div>
            <div
              className="relative mt-[-10px] flex-1"
              data-aos="zoom-in-up"
              data-aos-anchor-placement="top-bottom"
            >
              <Image src="/how-earnings-work/watchtime.png" alt="Watchtime" />
            </div>
          </div>
        </section>

        <section
          className="mx-auto my-4 w-full max-w-[1200px] grow bg-white md:my-0 md:w-[90%] md:py-8"
          id="learn-more"
        >
          <Flex
            flexDir={['column-reverse', 'column-reverse', 'row']}
            className="flex w-full  items-center justify-center gap-5 overflow-hidden px-4 py-5 md:px-16 lg:px-16"
          >
            <div
              className="relative mt-10 flex-1"
              data-aos="zoom-in-up"
              data-aos-anchor-placement="top-bottom"
            >
              <Image src="/how-earnings-work/ad_rates.png" alt="Watchtime" />
            </div>
            <div className="flex w-full flex-1 flex-col pr-0 sm:text-center lg:pr-16 lg:text-left">
              <h2
                className="pb-6 text-xl font-bold text-text-black sm:text-2xl md:text-3xl"
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
              >
                Geographical Ad Rates
              </h2>

              <p
                className="mb-5 text-base leading-6 text-text-black/80"
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
              >
                Ad rates differ across countries, with variations based on the
                market’s currency value, affecting the value of ad impressions
                in each country.
              </p>

              <p
                className="text-base leading-6 text-text-black/80"
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
              >
                For example, ad impressions may generate higher revenue in the
                USA compared to India due to the higher valuation of ad spaces
                in the American market.
              </p>

              <br />

              <Link href={'/home'}>
                <Button
                  color={'white'}
                  bg={'lyk-green'}
                  _hover={{ opacity: 0.6 }}
                >
                  Get started
                </Button>
              </Link>
            </div>
          </Flex>
        </section>

        {/* ================= Viewer Wallet Explainer Page Copy ================= */}

        <section
          className="mx-auto  mb-0 w-full max-w-[1200px] grow bg-white  md:w-[90%] md:py-8"
          id="viewer-wallet"
        >
          <div className="flex w-full flex-col gap-3 overflow-hidden px-4 py-5 md:px-16  lg:px-16">
            <h2 className="pb-3 text-xl font-bold text-text-black sm:text-2xl md:text-3xl">
              Your Attention Has Value.
            </h2>

            <p className="text-base leading-6 text-text-black/80">
              When your watch time qualifies, it can create rewards.
            </p>

            <h3 className="font-semibold mt-4 text-xl">How Viewer Rewards Work</h3>

            <ul className="pl-5 text-text-black/80" style={{ listStyleType: "disc" }}>
              <li>Watch while logged in.</li>
              <li>Ads are served during content.</li>
              <li>When ads are fully viewed, eligible sessions become monetized.</li>
              <li>Rewards may be tied to that monetized watch time.</li>
            </ul>

            <p className="text-base leading-6 text-text-black/80" style={{ marginTop: '1rem' }}>
              If you are not logged in, creators can still earn — but viewer rewards require login.
            </p>

            <h3 className="font-semibold mt-4 text-xl">Why This Is Different</h3>

            <p className="text-base leading-6 text-text-black/80">
              On most online video sharing platforms, viewer attention fuels revenue but goes unrecognized.
              <br />On LYKSTAGE:
              <ul className="pl-5 text-text-black/80" style={{ listStyleType: "disc" }}>
                <li>Creators earn first.</li>
                <li>Viewers can participate when eligible.</li>
                <li>Value flow becomes visible.</li>
              </ul>
            </p>

            <h3 className="font-semibold mt-4 text-xl">What You See in Your Wallet</h3>

            <ul className="pl-5 text-text-black/80" style={{ listStyleType: "disc" }}>
              <li>Reward balance</li>
              <li>Monetized watch time</li>
              <li>Redemption eligibility</li>
              <li>Transaction history</li>
            </ul>

            <p className="text-base leading-6 text-text-black/80">Your attention is measurable. And now, it’s acknowledged.</p>

            <Link href={user ? '/home' : '/auth/signup'}>
              <Button bg={'lyk-green'} color={'white'} _hover={{ opacity: 0.6 }} mt={5}>
                Start Watching
              </Button>
            </Link>
          </div>
        </section>

        <section>
          <Footer />
        </section>
      </div>
    </>
  )
}
